export const addUtmParametersToUrl = (baseUrl: string, utmParams: Record<string, string | null | undefined>) => {
  if (!baseUrl) return '';
  // Ensure base URL has a protocol
  let currentUrl = baseUrl;
  if (!currentUrl.startsWith('http://') && !currentUrl.startsWith('https://')) {
    currentUrl = `https://${currentUrl}`;
  }

  const urlObject = new URL(currentUrl);
  const searchParams = urlObject.searchParams;

  Object.keys(utmParams).forEach(key => {
    if (key.startsWith('utm_')) {
      const value = utmParams[key];
      // If the value is not empty, not just whitespace, and not 'none', set it.
      if (value && typeof value === 'string' && value.trim() !== '' && value.toLowerCase() !== 'none') {
        searchParams.set(key, value);
      } else {
        // If the value is empty, null, undefined, 'none', or just whitespace, delete the parameter.
        searchParams.delete(key);
      }
    }
  });

  return urlObject.toString();
};

export const extractUtmParametersFromUrl = (url: string) => {
  if (!url) return null;
  
  try {
    if (!url.startsWith('http')) url = `https://${url}`;
    
    const urlObj = new URL(url);
    const params = urlObj.searchParams;
    
    // Check if there are any UTM parameters
    const utmParams = {
      utm_campaign: params.get('utm_campaign') || '',
      utm_medium: params.get('utm_medium') || '',
      utm_source: params.get('utm_source') || '',
      utm_term: params.get('utm_term') || '',
      utm_content: params.get('utm_content') || ''
    };
    
    // Check if at least one UTM parameter exists
    const hasUtmParams = Object.values(utmParams).some(value => value !== '');
    
    return hasUtmParams ? utmParams : null;
  } catch (error) {
    console.error('Error extracting UTM parameters:', error);
    return null;
  }
};
